@import "../../sass/variables/variables";

.uxn-notification-item {
	display: flex;
	flex-direction: column;
	position: relative;
	width: 100%;

	@media only screen and (min-width: $tablet) {
		display: block;
	}
}

.uxn-notification-item__icon-wrapper {
	align-items: center;
	display: flex;
	margin-bottom: $dim-10;

	.ux-icon {
		font-size: 48px;
	}
}

.uxn-notification-item__source-date {
	flex-direction: column;
	margin-left: 15px;
	width: 100%;

	.uxn-notification-item__date-time {
		font-size: var(--uxn-notification-item-date-time-font-size);
		display: flex;
		gap: 15px;
		align-items: center;
	}

	.uxn-notification-item__date {
		margin-left: 10px;
	}

	.uxn-notification-item__delete-tooltip {
		position: relative;
		display: inline-block;
		cursor: pointer;

		> .ux-icon {
			margin-left: 4px;
		}

		+ .tooltip-text {
			padding: 19px 16px;
			position: absolute;
			max-width: 100%;
			background-color: white;
			z-index: 900;
			box-shadow: -2px 0 22px 2px rgba(19, 19, 19, 0.08);
			box-shadow: -2px 0 22px 2px rgba(19, 19, 19, 0.08);
			transform: translateY(-10px);
			pointer-events: none;
			opacity: 0;
			transition:
				opacity 300ms ease-in-out,
				transform 300ms ease-in-out;
			width: 80%;
			right: 0;
		}

		&:hover + .tooltip-text {
			visibility: visible;
			transform: translateY(0);
			opacity: 1;
		}
	}
}

.uxn-notification-item__status-wrapper {
	position: absolute;
	right: 10px;
	top: 5px;
}

// Type modifier
.uxn-notification-item--overview {
	align-items: flex-start;
}

.uxn-notification-item--detail {
	@media only screen and (min-width: $desktop-s) {
		align-items: center;
	}

	.uxn-notification-item__icon-wrapper {
		@media only screen and (min-width: $tablet) {
			width: 85px;
		}
		/* stylelint-disable max-nesting-depth, selector-max-compound-selectors */
		.ux-icon {
			@media only screen and (min-width: $tablet) {
				font-size: 48px * 1.33;
			}
		}
		/* stylelint-enable max-nesting-depth, selector-max-compound-selectors */
	}
}
